import { render, staticRenderFns } from "./HeaderStyle1.vue?vue&type=template&id=486fa70c"
import script from "./HeaderStyle1.vue?vue&type=script&lang=js"
export * from "./HeaderStyle1.vue?vue&type=script&lang=js"
import style0 from "./HeaderStyle1.vue?vue&type=style&index=0&id=486fa70c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports